import { Obligation, RiskLevel } from '../types/assessment'

export const EU_AI_ACT_OBLIGATIONS: Obligation[] = [
  {
    id: 'OBL-001',
    title: 'Risk Management System',
    description:
      'A risk management system must be established, implemented, documented and maintained.',
    category: 'Governance',
    riskLevel: ['High'],
  },
  {
    id: 'OBL-002',
    title: 'Data Governance',
    description:
      'Training, validation and testing datasets must be relevant, representative, free of errors and complete.',
    category: 'Data',
    riskLevel: ['High'],
  },
  {
    id: 'OBL-003',
    title: 'Technical Documentation',
    description:
      'Technical documentation must be drawn up before the system is placed on the market and kept up to date.',
    category: 'Documentation',
    riskLevel: ['High', 'Limited'],
  },
  {
    id: 'OBL-004',
    title: 'Record Keeping',
    description:
      'The system must automatically record events (logs) over its lifetime.',
    category: 'Technical',
    riskLevel: ['High'],
  },
  {
    id: 'OBL-005',
    title: 'Transparency',
    description:
      "The system must be designed to ensure that operation is sufficiently transparent to enable users to interpret the system's output.",
    category: 'Transparency',
    riskLevel: ['High', 'Limited'],
  },
  {
    id: 'OBL-006',
    title: 'Human Oversight',
    description:
      'The system must be designed to be overseen by natural persons.',
    category: 'Governance',
    riskLevel: ['High'],
  },
  {
    id: 'OBL-007',
    title: 'Accuracy, Robustness & Cybersecurity',
    description:
      'The system must achieve an appropriate level of accuracy, robustness and cybersecurity.',
    category: 'Technical',
    riskLevel: ['High'],
  },
  {
    id: 'OBL-008',
    title: 'Registration',
    description: 'The system must be registered in the EU database.',
    category: 'Legal',
    riskLevel: ['High'],
  },
]

export const EVIDENCE_TYPES = [
  'Policy Document',
  'Technical Specification',
  'Training Data Description',
  'Testing Report',
  'Risk Assessment',
  'Human Oversight Procedure',
  'Cybersecurity Audit',
  'Other',
]

export const determineRiskLevel = (
  answers: Record<string, boolean>,
): RiskLevel => {
  // Simplified logic for demo purposes
  if (
    answers['critical_infrastructure'] ||
    answers['biometric_id'] ||
    answers['employment_decisions']
  ) {
    return 'High'
  }
  if (answers['chatbot'] || answers['emotion_recognition']) {
    return 'Limited'
  }
  return 'Minimal'
}
